<template>
  <a-drawer
    v-if="retreatmentVisible"
    :title="prop.isBatch ? '批量修改复诊日期' : '修改复诊日期'"
    placement="right"
    :visible="retreatmentVisible"
    :body-style="{ background: '#FFF', padding: 0 }"
    :headerStyle="{ background: '#FFF' }"
    @close="retreatmentVisible = false"
    width="400"
    :maskClosable="false"
  >
    <div class="content" :style="{ height: 'calc(100vh - 120px)' }">
      <a-spin :spinning="loading">
        <!-- 复诊预约单 -->
        <div v-if="curDayTreatedList.length > 0">
          <template v-for="(order, ordeDex) in curDayTreatedList" :key="ordeDex">
            <!-- 只展示带就诊的数据 -->
            <div class="orderItem orderItemActive" v-if="order.reserveState === 3">
              <div>
                <div class="orderHead">
                  复诊预约单
                  <span style="color: #1890ff" v-if="order.id">（ID:{{ order.id }}）</span>
                </div>
                <div class="orderContent">
                  <text>
                    {{ order.reserveDateStr }}｜{{ reVisitType[Number(order.revisitType)] }}
                  </text>
                </div>
              </div>
              <div
                class="orderRelated"
                v-if="order.reserveSourceRelations.every(item => item.businessId)"
              >
                <a
                  href="#"
                  v-for="(relate, relateIndex) in order.reserveSourceRelations"
                  :key="relateIndex"
                  style="margin-right: 12px; font-size: 12px"
                  @click="handleBussinessModal(relate)"
                >
                  {{ `关联${relate.businessType === 1 ? '病历' : '处方'}${relateIndex + 1}` }}
                </a>
              </div>
              <div class="orderStatus warning">
                {{ Config.RESERCE_STATE_MAP[order.reserveState] }}
              </div>
            </div>
          </template>
        </div>
        <div style="position: relative">
          <div class="space" v-if="curDayTreatedList.length"></div>
          <NeedChangeRetreatOrder ref="orderRef" :itemInfo="itemInfo" :isBatch="prop.isBatch" />
        </div>
      </a-spin>
      <div class="footer" v-if="prop.isBatch || curDayTreatedList.length">
        <a-button @click="retreatmentVisible = false" :disabled="loading" class="cancle">
          取消
        </a-button>
        <a-button type="primary" @click="handleSubmitOrder" :disabled="loading" class="save">
          确定
        </a-button>
      </div>
    </div>
    <RecordDetail v-model:visible="recordVisible" recordType="offLineRecord" :id="recordId" />
    <the-detail
      v-model:visible="presVisible"
      :serialNumber="serialNumber"
      recordType="prescriptionOnline"
    />
  </a-drawer>
</template>
<script setup>
import { ref, defineExpose, defineProps, computed, defineEmits } from 'vue'
import moment from 'moment'
import {
  apiReverseDateList,
  apiDayReverseInfo,
  apiSubTaskHandle
} from '@/api/workPlace/retreatment.js'
import NeedChangeRetreatOrder from './needChangeRetreatOrder'
import { useStore } from 'vuex'
import Config from '@/config/index'
import { message } from 'ant-design-vue'
import RecordDetail from '@/components/TheDetail'
import TheDetail from '@/components/TheDetail/index.vue'
import { debounce } from 'lodash-es'
import { reVisitType } from './config'
import { REFRESH_MAIN } from '@/views/WorkPlace/handleEventBuss'

const store = useStore()
const retreatmentVisible = ref(false)
const curWorkOrderInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
const curDate = ref(null)
const userInfo = computed(() => store.getters.userInfo)
const itemInfo = ref({})
const appointList = ref([])
// const selectPushDate = ref([])
const emits = defineEmits(['dueCallBack'])
const prop = defineProps({
  // 是否批量
  isBatch: {
    type: Boolean,
    default: false
  }
})
// 初始化
const treatmentInit = async (item, businessId = null) => {
  const { reserveDate = '' } = item
  retreatmentVisible.value = true
  itemInfo.value = item
  //获取预约单详情
  if (businessId) {
    curDate.value = moment(reserveDate).format('YYYY-MM-DD')
    fetchReverseList()
  } else {
    curDayTreatedList.value = []
  }
}
// 获取全部复诊预约单日期列表
const fetchReverseList = () => {
  appointList.value = []
  apiReverseDateList({
    ucDoctorId: curWorkOrderInfo.value.doctorInfo.ucUserId || itemInfo.value.ucDoctorId,
    ucPatientId: itemInfo.value.ucPatientId
  }).then(res => {
    appointList.value = res
    getList(curDate.value)
  })
}

const loading = ref(false)
const curDayTreatedList = ref([])
const getList = ctx => {
  curDayTreatedList.value = []
  const dataFormat = moment(ctx).format('YYYY-MM-DD')
  // 如果当前复诊预约单时间在预约单列表中
  if (appointList.value.includes(dataFormat)) {
    loading.value = true
    // 获取预约单卡片详情
    apiDayReverseInfo({
      ucDoctorId: curWorkOrderInfo.value.doctorInfo.ucUserId,
      ucPatientId: itemInfo.value.ucPatientId,
      reserveDate: dataFormat,
      relationDetail: true
    }).then(res => {
      curDayTreatedList.value = res.list
      loading.value = false
    })
  }
}
const orderRef = ref()
const handleSubmitOrder = debounce(async () => {
  try {
    const formParams = await orderRef.value.submitForm()
    const { taskId = '', workOrderId } = itemInfo.value
    const dateMoment = moment(formParams.reserveDate, 'YYYY-MM-DD HH:mm:ss')
    const paramsData = {
      ...formParams,
      reserveDate: dateMoment.valueOf()
    }
    const params = {
      operatorEnum: 1,
      subTaskBusinessType: 'DA_CURE_RESERVE_ORDER',
      taskId,
      operatorName: userInfo.value.realName,
      subTaskBusinessData: JSON.stringify(paramsData),
      reserveEntry: 11,
      modifyReserveDateFlag: 1,
      hasQualityInspection: true, //质检场景下都传true，进行校验质检情况
      workOrderId
    }
    loading.value = true
    apiSubTaskHandle(params)
      .then(() => {
        dueCallBack()
      })
      .catch(() => {
        REFRESH_MAIN?.emit()
      })
      .finally(() => {
        loading.value = false
      })
  } catch (error) {
    message.warning('请选择必填项！')
    console.log('error', error)
  }
}, 400)

// 关联病历
const recordId = ref('')
const recordVisible = ref(false)
// 关联处方
const serialNumber = ref('')
const presVisible = ref(false)
const handleBussinessModal = ctx => {
  if (ctx.businessType === 1) {
    recordVisible.value = true
    recordId.value = ctx.businessId
  }
  if (ctx.businessType === 2) {
    presVisible.value = true
    serialNumber.value = ctx.serialNumber
  }
}

const dueCallBack = async () => {
  message.success('提交成功！')
  retreatmentVisible.value = false
  emits('dueCallBack')
}

defineExpose({
  treatmentInit
})
</script>

<style scoped lang="scss">
.space {
  border-top: 10px solid #f5f5f5;
  position: absolute;
  top: 0;
  width: 100%;
  right: 0;
}
.events,
.passed {
  width: 16px;
  height: 16px;
  background: #2ed1b5;
  border-radius: 4px;
  overflow: hidden;
  position: absolute;
  top: -51px;
  right: -5px;
  z-index: 999;
  color: #fff;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.passed {
  background-color: #f0f0f0;
  color: #999999;
}

::v-deep .ant-fullcalendar-column-header {
  text-align: left;
  text-indent: 13px;
}

::v-deep .ant-fullcalendar-header .ant-radio-group {
  display: none;
}

::v-deep .ant-fullcalendar-today .ant-fullcalendar-value {
  box-shadow: none;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #1890ff;
  border-radius: 8px;
}

::v-deep .ant-fullcalendar-date {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 2px;
  color: #333;
}

::v-deep .ant-fullcalendar-selected-day .ant-fullcalendar-value {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1890ff;
  border-radius: 8px;
  color: #fff;
}

::v-deep .ant-fullcalendar {
  border-top: none;
}

.content {
  overflow: auto;
  padding-bottom: 40px;
}

.orderDateTips {
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
  background: rgba(244, 89, 89, 0.08);
  font-size: 14px;
  color: #f45959;
  padding: 0 16px;
}

.orderItem {
  background: #f5f5f7;
  border-radius: 8px;
  margin-bottom: 12px;
  position: relative;
  margin: 12px 18px 20px;
  border: 1px solid transparent;

  .orderHead {
    font-size: 13px;
    color: #999999;
    border-bottom: 1px solid #e3e3e3;
    padding: 8px 16px;
  }
  .orderContent {
    padding: 12px 16px;
    color: #1b1b1b;
    font-size: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .orderRelated {
    padding: 0px 16px 12px;
  }
  .orderStatus {
    position: absolute;
    top: 0;
    right: 0;
    background: #2ed1b5;
    border-radius: 0 8px 0 8px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    padding: 3px 5px;
    &.primary {
      background: #4c6ee0;
    }
    &.cancel {
      background: #9e9e9e;
    }
    &.warning {
      background: #f4ae54;
    }
  }
}

.orderItemActive {
  border: 1px solid #1e7bff;
  border-radius: 8px;
  background-color: rgba(152, 215, 255, 0.15);
}

.helpHandle {
  height: 58px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  border-bottom: 1px solid #f0f0f0;
  border-top: 10px solid #f5f5f5;
  .tit {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    margin-right: 40px;
  }
  .action {
    font-size: 14px;
    flex: 1;
    display: flex;
    justify-content: space-between;
  }
}

.footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 15px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;

  .cancle {
    width: 112px;
    margin-right: 12px;
    height: 36px;
    font-size: 16px;
  }
  .save {
    width: 112px;
    height: 36px;
    font-size: 16px;
  }
}
</style>
